/**
 * @file_purpose  axios api call for handling apis for admin
 * @author Sucheta Singha
 * @Date_Created 
 * @Date_Modified 01-03-2023
 */
import API from '../apis/API';
import ApiURL from '../apis/ApiURL';
const accessToken = localStorage.getItem("hrms_employee_auth");

const Service = {
    login: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.login}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    generateOTP: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.generateOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },
    verifyOTP: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.verifyOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    resendOTP: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.resendOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    changePassword: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.changePassword}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },



    users: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.users}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },



    departments: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.departments}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    designations: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.designations}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    getOrganizationChart: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getOrganizationChart}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    userDetails: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.userDetails}` + params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },




    locations: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.locations}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    company: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.company}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    employee_status: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.employee_status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    employee_type: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.employee_type}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    getDocumentList: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getDocumentList}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    cityList: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.cityList}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    allUsers: function () {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.allUsers}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    allUsersCompanyWise: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.allUsersCompanyWise}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    clockIn: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.clockIn}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    clockOut: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.clockOut}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    clockInOutStatus: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.clockInOutStatus}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    teamMembersList: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.teamMembersList}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    forgotPasswordClick: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.forgotPasswordClick}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    verifyForgotPasswordOTP: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.verifyForgotPasswordOTP}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    resetForgotPassword: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.resetForgotPassword}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    forcefullyChangePassword: function (params, token) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.changePassword}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    getAllDocumentsList: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getAllDocumentsList}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    kraCategoryList: function (params) {
        return new Promise((resolve, reject) => {
            API.get(`${ApiURL.kraCategoryList}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },

    getKRADetails: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getKRADetails}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })

        })
    },


    getAllDocumentsType: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getAllDocumentsType}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    getCVDetails: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getCVDetails}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    saveCVDetails: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.saveCVDetails}`, params, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    cvDownload: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.cvDownload}`, params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,

                    },
                    responseType: 'blob'

                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    cvDownloadHTML: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.cvDownloadHTML}`, params,
                // {responseType: 'blob'},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,

                    },

                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },

    getTrackerBuildDetails: function (params) {
        return new Promise((resolve, reject) => {
            API.post(`${ApiURL.getTrackerBuildDetails}`,params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,

                    },
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                })
        })
    },




}

export default Service;
